import { useLazyQuery } from '@apollo/client';
import { Button } from 'antd';
import { FC, useEffect, useMemo, useState } from 'react';
import { ReviewDocumentsModal } from '../../../../../shared/review-documents/review-documents-modal';
import { FileInfo, CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1Document } from '../../../../../../generated';
import { ReviewDocumentDocumentInfo, getDocumentInfo } from '../../../../../shared/review-documents/review-documents-helpers';

const DOCUMENT_CONFIG = {
  'passport.jpg': { title: 'Passport' },
  'passport-expiration-page': { title: 'Expiration Passport' },
  'passport-translation.pdf': { title: 'Passport Translation' },
  'photo.jpg': { title: 'Photo' },
  'id-form.pdf': { title: 'ID Form' },
  'id-form-notarized.pdf': { title: 'ID Form Notarized' },
  'id-form-notarized-redacted.pdf': { title: 'ID Form Notarized Redacted' }
} as ReviewDocumentDocumentInfo;

function useDocumentComparison(caseId: string) {
  const [isOpen, setIsOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [fetchFiles, { data }] = useLazyQuery(CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1Document);

  useEffect(() => {
    if (isFetching) {
      fetchFiles({
        variables: { id: caseId },
        fetchPolicy: 'network-only'
      }).then(() => {
        setIsFetching(false);
        setIsOpen(true);
      });
    }
  }, [isFetching, caseId]);

  const documentInfos = useMemo(() => {
    const files = data?.identityVerificationCaseV1?.files as FileInfo[];
    return files?.length ? getDocumentInfo(files, DOCUMENT_CONFIG) : {};
  }, [data]);

  return {
    isOpen,
    isFetching,
    documentInfos,
    startComparison: () => setIsFetching(true),
    closeModal: () => {
      setIsOpen(false);
    }
  };
}

interface ReviewDocumentsButtonContainerProps {
  caseId: string;
}
export const ReviewDocumentsButtonContainer: FC<ReviewDocumentsButtonContainerProps> = (props) => {
  const { isOpen, isFetching, documentInfos, startComparison, closeModal } = useDocumentComparison(props.caseId);

  return (
    <>
      <Button loading={isFetching} onClick={startComparison}>
        Review Documents
      </Button>
      <ReviewDocumentsModal isOpen={isOpen} onClose={closeModal} documentInfos={documentInfos} />
    </>
  );
};
